import axios from "axios";
import { appConstants } from "./appConstants";
import { clearCachedRequest, getCachedRequest } from "./requestCache";

const generations = new Map();
const scopeKey = (type, businessUserID) => `${businessUserID}:${type}`;
const cacheKey = (type, businessUserID) =>
  `billing-number:${scopeKey(type, businessUserID)}:${generations.get(scopeKey(type, businessUserID)) || 0}`;

export function getBillingNumberPreview(type, businessUserID) {
  if (!businessUserID) return Promise.reject(new Error("Business User ID is required."));
  const key = cacheKey(type, businessUserID);
  return getCachedRequest(key, async () => {
    const { data } = await axios.post(
      `${appConstants.baseURL}invoice/getDocumentNumber`,
      { businessUserID, documentType: type },
      { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }, timeout: 15000 }
    );
    if (!data?.Result_Status || !data.Result_Output?.[`${type}Number`])
      throw new Error("Could not generate the document number. Please try again.");
    return data.Result_Output[`${type}Number`];
  }, 15000).then((number) => {
    if (key !== cacheKey(type, businessUserID)) clearCachedRequest(key);
    return number;
  });
}

export function clearBillingNumberPreview(type, businessUserID) {
  clearCachedRequest(cacheKey(type, businessUserID));
  generations.set(scopeKey(type, businessUserID), (generations.get(scopeKey(type, businessUserID)) || 0) + 1);
}
